import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import Swal from "sweetalert2";
import { useCart } from "../Context/CartContext";

export default function CartSidebar({ show, handleClose }) {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    if (show) {
      GetCartProducts();
    }
  }, [show]);

  const GetCartProducts = async () => {
    try {
      const productIds = JSON.parse(localStorage.getItem("cart")) || [];

      if (productIds.length === 0) {
        setCart([]);
        return;
      }

      const response = await fetch(
        "https://api.domehelp.com/ProductInformation/GetCartProducts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ProductIds: productIds,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to load cart.");
      }

      const data = await response.json();

      setCart(data);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  const { removeItem } = useCart();

  const handleRemove = (productId) => {
    removeItem(productId);

    Swal.fire({
      toast: true,
      icon: "success",
      position: "top-end",
      title: "Product removed from cart",
      showConfirmButton: false,
      timer: 2000,
    });

    setCart((prev) => prev.filter((item) => item.productId !== productId));
  };

  const subtotal = cart.reduce((total, item) => total + Number(item.price), 0);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="cart-sidebar"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <div className="cart-title">
            <i className="bi bi-cart3"></i>
            <span>Cart ({cart.length})</span>
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0 d-flex flex-column">
        {cart.length === 0 ? (
          <div className="empty-cart">
            <i className="bi bi-cart-x empty-icon"></i>
            <h5>Your cart is empty</h5>
            <p>Add products to continue.</p>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cart.map((item) => (
                <div className="cart-item" key={item.productId}>
                  <div className="cart-image">
                    <div className="cart-image">
                      {item.image ? (
                        <img
                          src={`https://api.domehelp.com/ProductDoc/${item.image}`}
                          alt={item.name}
                          className="img-fluid rounded"
                        />
                      ) : (
                        <i className="bi bi-file-earmark-excel-fill excel-icon"></i>
                      )}
                    </div>
                  </div>

                  <div className="cart-details">
                    <h6>{item.name}</h6>

                    <small>Excel / CSV Dataset</small>

                    <div className="price">₹{item.price}</div>
                  </div>

                  <button
                    className="remove-btn"
                    onClick={() => handleRemove(item.productId)}
                  >
                    <i className="bi bi-trash3"></i>
                  </button>
                </div>
              ))}
            </div>

            <div className="cart-footer">
              <div className="subtotal">
                <span>Subtotal</span>
                <strong>₹{subtotal}</strong>
              </div>

              <Link
                to="/Checkout"
                className="checkout-btn"
                onClick={handleClose}
              >
                Checkout
              </Link>
            </div>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
}
